import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { forwardRef } from "react";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { Faded } from "baby-i-am-faded";
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
export function DropDownMenu(props) {
    var children = props.children, button = props.button;
    return /*#__PURE__*/ _jsxs(Menu, {
        as: "div",
        className: classNames("relative inline-block text-left", props.className),
        children: [
            /*#__PURE__*/ _jsx(Menu.Button, {
                as: "div",
                children: button
            }),
            _jsx(_JSXStyle, {
                id: "7d14bef2eb999215",
                children: "@-webkit-keyframes menuAppear{from{opacity:0;-webkit-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@-moz-keyframes menuAppear{from{opacity:0;-moz-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@-o-keyframes menuAppear{from{opacity:0;transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}@keyframes menuAppear{from{opacity:0;-webkit-transform:translate3d(0px,-2em,0px)scale(0);-moz-transform:translate3d(0px,-2em,0px)scale(0);transform:translate3d(0px,-2em,0px)scale(0)}to{opacity:1}}"
            }),
            /*#__PURE__*/ _jsx(Faded, {
                animationName: "menuAppear",
                duration: 120,
                cascade: true,
                children: /*#__PURE__*/ _jsx(Menu.Items, {
                    className: "absolute border py-1 right-0 w-56 mt-2 origin-top-right bg-white rounded-md shadow-lg dark:bg-gray-800 ring-1 ring-black ring-opacity-5 focus:outline-none",
                    children: children
                })
            })
        ]
    });
}
DropDownMenu.Button = Button;
function Button(_param) {
    var className = _param.className, children = _param.children, props = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs("button", {
        className: classNames("inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 dark:hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500", "cursor-pointer", className),
        children: [
            children,
            /*#__PURE__*/ _jsx(ChevronDownIcon, {
                className: "w-5 h-5 ml-2 -mr-1",
                "aria-hidden": "true"
            })
        ]
    });
}
var Item = /*#__PURE__*/ forwardRef(function Item(_param, ref) {
    var _icon = _param.icon, icon = _icon === void 0 ? null : _icon, children = _param.children, _className = _param.className, className = _className === void 0 ? "" : _className, rest = _object_without_properties(_param, [
        "icon",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ _jsx(Menu.Item, {
        children: function(param) {
            var active = param.active;
            return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
                className: classNames(active ? "bg-gray-100 text-gray-900" : "", "flex space-x-3 px-4 py-2 text-sm rounded-md m-1", "cursor-pointer", className),
                ref: ref
            }, rest), {
                children: [
                    icon,
                    /*#__PURE__*/ _jsx("div", {
                        className: "",
                        children: children
                    })
                ]
            }));
        }
    });
});
DropDownMenu.Item = Item;
